/* eslint-disable */
export default {
  toolTip: 'Afficher dans {crmName}',
} as const;

// @key: @#@"toolTip"@#@ @source: @#@"View in {crmName}"@#@
